import React, {FC, useCallback, useRef, useState} from 'react';
import ReactAudioPlayer from 'react-audio-player';

import './styles.scss';
import playIcon from 'assets/svg/match_player_live_broadcast_play.svg';
import stopIcon from 'assets/svg/match_player_live_broadcast_stop.svg';

interface broadcastProps {
  liveBroadcastParams: {
    channel: string,
    activity: boolean,
  };
}

const LiveBroadcastPlayer: FC<broadcastProps> = ({liveBroadcastParams} : broadcastProps) => {
  const [canPlay, setCanPlay] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const player = useRef<ReactAudioPlayer>(null);
  let broadcastURL = "";
  let liveBroadcastActivity = false;

  if (liveBroadcastParams.channel === "ch1") {
    broadcastURL = `${process.env.REACT_APP_LIVE_BROADCAST_URL_1}`
  }
  else if (liveBroadcastParams.channel === "ch2") {
    broadcastURL = `${process.env.REACT_APP_LIVE_BROADCAST_URL_2}`
  }
  else if (liveBroadcastParams.channel === "ch-backup") {
    broadcastURL = `${process.env.REACT_APP_LIVE_BROADCAST_URL_BACKUP}`
  }
  if (liveBroadcastParams.activity != null) {
    liveBroadcastActivity = liveBroadcastParams.activity;
  }
  
  const togglePlay = useCallback(() => {
    if (player.current && player.current.audioEl.current) {
      if (isPlaying) {
        setIsPlaying(false);
        player.current.audioEl.current.pause();
        /* NOTE: the line below (27) fixes the bug in task [SUP-54] */
        player.current.audioEl.current.src = broadcastURL;
      } else {
        setIsPlaying(true);
        player.current.audioEl.current.play();
      }
    }
  }, [broadcastURL, isPlaying]);

  return (
    <button
      type="button"
      className={`LiveBroadcastPlayer 
      ${isPlaying ? 'LiveBroadcastPlayer--is-playing' : ''}
      ${liveBroadcastActivity === false ? 'LiveBroadcastPlayer--hidden' : ''}
      `}
      onClick={() => togglePlay()}
    >
      <img className="LiveBroadcastPlayer__icon"
      src={isPlaying ? stopIcon : playIcon}
      alt={isPlaying ? 'stop' : 'play'} />
      <span className="LiveBroadcastPlayer__label">ΗΧΗΤΙΚΗ ΜΕΤΑΔΟΣΗ</span>
      <ReactAudioPlayer
        ref={player}
        src={broadcastURL}
        // onCanPlay={() => setCanPlay(true)}
        onError={() => setCanPlay(false)}
      />
    </button>
  );
};
/* NOTE: [line:38] onCanPlay is never fired in safari OSX & iOS and can play never changes to true.
         [SUP-52] to solve the problem changed the initial value of canPlay to true [line:8]
         and comment onCanPlay since is not working in safari.
         Also don't understand why to start with the component hidden [line: 31],
         At the parent component (src/components/Match/HeaderInfo/index.tsx) we check if the hasLiveBroadcast,
         from the match data, is set to true so to print or not the audio!
*/
export default LiveBroadcastPlayer;
